import * as types from "./mutation-types";
import Vue from "vue";

import Cookies from "js-cookie";

/* eslint-disable */
export default {
  [types.LOGIN_SUCCESS](state, { userp, access_tokenp, rolep }) {
    let aTtoken = "Bearer " + access_tokenp;

    Cookies.set("access_tokenp", aTtoken);
    Cookies.set("rolep", JSON.stringify(rolep));
    Cookies.set("userp", userp);

    state.access_tokenp = aTtoken;
    state.rolep = rolep;
    state.userp = userp;

    axios.defaults.headers.common["Authorization"] = aTtoken;
  },

  [types.LOGIN_FAILURE](state) {
    state.access_tokenp = "";
    state.rolep = [];
    state.userp = {};

    Cookies.remove("access_tokenp");
    Cookies.remove('rolep');
    Cookies.remove("userp");
  },


  [types.LOGOUT](state) {
    state.access_tokenp = "";
    state.rolep = [];
    state.userp = {};

    Cookies.remove("access_tokenp");
    Cookies.remove('rolep');
    Cookies.remove("userp");
    delete axios.defaults.headers.common["Authorization"];
  },

  [types.UPDATE_USER](state, { userp }) {
    Cookies.set("userp", userp);
    Vue.set(state, "userp", userp);
  }
};
